import { BrandIdvTokenDataFn } from "../../instantAnswerDataFunctions/brandIdvTokenDataFn";
import { getSubmitVerificationInformationCTA } from "./shared";
export var SubmitRequestedInformationIA = function SubmitRequestedInformationIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getSubmitVerificatio;
        return (_getSubmitVerificatio = getSubmitVerificationInformationCTA(context, strictLocalize)) === null || _getSubmitVerificatio === void 0 ? void 0 : _getSubmitVerificatio.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getSubmitVerificatio2, _getSubmitVerificatio3;
        return (_getSubmitVerificatio2 = getSubmitVerificationInformationCTA(context, strictLocalize)) === null || _getSubmitVerificatio2 === void 0 ? void 0 : (_getSubmitVerificatio3 = _getSubmitVerificatio2.getLink) === null || _getSubmitVerificatio3 === void 0 ? void 0 : _getSubmitVerificatio3.call(_getSubmitVerificatio2);
      }
    },
    additionalRequiredData: [BrandIdvTokenDataFn]
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return SUBMIT_REQUESTED_INFORMATION_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return getDescriptionByContext(context, strictLocalize);
    }
  };
};
var getDescriptionByContext = function getDescriptionByContext(context, strictLocalize) {
  if (context.brandIdvToken) {
    return [SUBMIT_REQUESTED_INFORMATION_DESCRIPTION(strictLocalize)];
  }
  return [SUBMIT_REQUESTED_INFORMATION_BY_CONTACTING_US_DESCRIPTION(strictLocalize)];
};
var SUBMIT_REQUESTED_INFORMATION_TITLE = function SUBMIT_REQUESTED_INFORMATION_TITLE(strictLocalize) {
  return strictLocalize({
    id: "+fC0eh",
    defaultMessage: "Submit requested information"
  });
};
var SUBMIT_REQUESTED_INFORMATION_DESCRIPTION = function SUBMIT_REQUESTED_INFORMATION_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "Jx3Bqw",
    defaultMessage: "You can submit information for the verification of your Faire brand account using the button below."
  });
};
var SUBMIT_REQUESTED_INFORMATION_BY_CONTACTING_US_DESCRIPTION = function SUBMIT_REQUESTED_INFORMATION_BY_CONTACTING_US_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "EqAxDv",
    defaultMessage: "You can submit information for the verification of your Faire brand account by contacting us."
  });
};